// Client-side helpers for Razorpay backend API
// Can use either local server or Firebase Functions URL
const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

export async function createRazorpayOrder({ amount, currency = 'INR', receipt, notes }) {
  // Firebase Functions format: /payments/create-order
  // Local server format: /api/payments/create-order
  const endpoint = API_BASE.includes('cloudfunctions.net') 
    ? `${API_BASE}/create-order`
    : `${API_BASE}/api/payments/create-order`;
    
  const res = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount, currency, receipt, notes }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to create order');
  }
  const data = await res.json();
  return data.order;
}

export async function verifyRazorpayPayment({ razorpay_order_id, razorpay_payment_id, razorpay_signature }) {
  // Firebase Functions format: /payments/verify
  // Local server format: /api/payments/verify
  const endpoint = API_BASE.includes('cloudfunctions.net')
    ? `${API_BASE}/verify`
    : `${API_BASE}/api/payments/verify`;
    
  const res = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ razorpay_order_id, razorpay_payment_id, razorpay_signature }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Verification failed');
  }
  return res.json();
}
